<!-- 可拖拽的小球 封装 -->
<template>
  <div class="Floating">
    <div
      ref="floatButton"
      class="backHome"
      @click.stop="showPopup"
      @touchstart="touchstart"
      @mousedown="touchstart"
      @touchmove="touchmove"
      @mousemove="touchmove"
      @touchend="touchend"
      @mouseup="touchend"
      :style="{
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        left: left + 'px',
        top: top + 'px',
      }"
    >
      <img v-if="netDelay <= 49" src="@/assets/imgs/xuanfu.png" />
      <img
        v-else-if="netDelay >= 50 && netDelay < 200"
        src="@/assets/imgs/xuanfu1.png"
      />
      <img v-else-if="netDelay >= 200" src="@/assets/imgs/xuanfu2.png" />
    </div>
  </div>
</template>
  <script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Floating",
  props: {
    itemWidth: {
      // 悬浮按钮宽度
      type: Number,
      default: 60,
    },
    itemHeight: {
      // 悬浮按钮高度
      type: Number,
      default: 60,
    },
    gapWidth: {
      // 距离左右两边距离
      type: Number,
      default: 0,
    },
    coefficientHeight: {
      // 从上到下距离比例
      type: Number,
      default: 0.72,
    },
    netDelay: {
      type: Number,
      default: 10,
    },
    floatPhone: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      top: 0,
      left: 0,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      timer: null,
      show: false,
      howLong: 0,
      duration: 0,
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth; // 手机宽度
    this.clientHeight = document.documentElement.clientHeight;
    this.getPlace();
  },
  mounted() {},
  computed: {
    ...mapState("perpetual", ["floatPlace"]),
  },
  methods: {
    ...mapMutations("perpetual", ["SET_FLOATPLACE"]),
    // 展开菜单
    showPopup() {
      // 桌面端适配
      if (this.duration > 150) {
        return;
      }
      this.$emit("xuanfuchuan");
    },
    getPlace() {
      const findItem = this.floatPlace.find(
        (item) => this.floatPhone.id == item.id
      );
      if (findItem) {
        this.left = findItem.left;
        this.top = findItem.top;
      } else {
        this.left = this.clientWidth - this.itemWidth - this.gapWidth;
        this.top = this.clientHeight * this.coefficientHeight;
      }
    },
    touchstart() {
      const floatButton = this.$refs.floatButton;
      floatButton.style.transition = "none";
      document.body.style.overflow = "hidden";
      this.howLong = new Date().getTime();
    },
    touchmove(e) {
      if (e.targetTouches && e.targetTouches.length === 1) {
        let touch = e.targetTouches[0];
        this.left = touch.clientX - 20;
        this.top = touch.clientY - 25;
      }
      //4、限制拖拽宽高
      if (this.left < 0) {
        this.left = 0;
        //如果拖拽元素定位的数值高于, 页面可视宽 - 拖拽元素自身宽 (可视页面最大宽)
      } else if (this.left > this.clientWidth - this.itemWidth) {
        //满足这个条件，就限制宽为，clientWidth-oDiv.offsetWidth(可视页面最大宽)
        this.left = this.clientWidth - this.itemWidth;
      }

      if (this.top < 0) {
        this.top = 0;
        //如果拖拽元素定位的数值高于, 页面可视高 - 拖拽元素自身高 (可视页面最大高)
      } else if (this.top > this.clientHeight - this.itemHeight) {
        //满足这个条件，就限制高为，clientHeight-oDiv.offsetHeight(可视页面最大高)
        this.top = this.clientHeight - this.itemHeight;
      }
    },
    touchend() {
      this.duration = new Date().getTime() - this.howLong;
      //   let isFloatAdsorb = JSON.parse(localStorage.getItem("isFloatAdsorb"));
      if (true) {
        const floatButton = this.$refs.floatButton;
        floatButton.style.transition = "all 0.3s";
        // document.body.style.overflow = "auto";
        if (this.left > document.documentElement.clientWidth / 2) {
          this.left = this.clientWidth - this.itemWidth - this.gapWidth;
          setTimeout(() => {
            this.left = this.clientWidth - this.itemWidth - this.gapWidth + 40;
          }, 2000);
        } else {
          this.left = 0;
          setTimeout(() => {
            this.left = this.left - 40;
          }, 2000);
        }
      }
      this.floatPhone.left = this.left;
      this.floatPhone.top = this.top;
      this.SET_FLOATPLACE(
        this.$common.checkAndUpdateArray(this.floatPlace, this.floatPhone, "id")
      );
    },
  },
};
</script>
   
  <style lang="less" scoped>
.backHome {
  position: fixed;
  // max-width: 414px;
  z-index: 999;
  img {
    width: 100%;
    height: 100%;
    pointer-events: none;
    object-fit: cover;
  }
}
</style>